import Board from "./Board";
import PlayerArea from "./PlayerArea";

const POSITION_MAP = {
  1: [3],
  2: [3, 4],
  3: [1, 7, 5],
  4: [0, 2, 7, 5],
  5: [1, 4, 7, 5, 3],
  6: [0, 2, 4, 7, 5, 3],
  7: [0, 1, 2, 4, 7, 5, 3],
  8: [0, 1, 2, 4, 7, 6, 5, 3],
};

export default function GameTable({ players = [], cards = [] }) {
  const gridSlots = [0, 1, 2, 3, null, 4, 5, 6, 7];
  const positions = POSITION_MAP[players.length] || [];

  const getPlayerForSlot = (slot) => {
    const playerIndex = positions.indexOf(slot);
    return playerIndex !== -1 ? players[playerIndex] : null;
  };

  return (
    <div className="GameTable">
      {gridSlots.map((slot, idx) =>
        slot === null ? (
          <div className="Cell Center" key={idx}>
            <Board cards={cards} />
          </div>
        ) : (
          <div className="Cell" key={idx}>
            {getPlayerForSlot(slot) && <PlayerArea {...getPlayerForSlot(slot)} />}
          </div>
        )
      )}
    </div>
  );
}
